<template>
  <div>
    <div style="margin-top: 10px">
      <el-form
        ref="form"
        :model="dataForm"
        label-width="100px"
        label-position="left"
      >
        <el-row>
          <el-col :span="2">
            <el-button
              @click="gotomain()"
              type="text"
              size="big"
              >返回</el-button
            >
          </el-col>

          <el-col :span="6">
            <el-form-item label="单号" style="width: 90%; margin-left: 10%">
              <el-input disabled v-model="dataForm.oMain.JOBNO"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-table :data="dataForm.lItem" border style="width: 100%">
            <el-table-column
              prop="packagezf"
              label="包号"
              width="120"
              header-align="center"
              v-if="true"
            ></el-table-column>
            <el-table-column
              prop="skuno"
              label="书号"
              width="160"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="skuname"
              label="书名"
              width="500"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="spubname"
              label="版别"
              width="160"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="sprice"
              label="定价"
              width="100"
              header-align="center"
              align="right"
            ></el-table-column>
            <el-table-column
              prop="quantity"
              label="数量"
              width="80"
              header-align="center"
              align="right"
            ></el-table-column>
            <!-- <el-table-column
                prop="Author"
                label="作者"
                width="280"
                header-align="center"
              ></el-table-column> -->
            <!-- <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="showorderitmedetail(scope.row)"
                    type="text"
                    size="small"
                    >商品详情</el-button
                  >
                </template>
              </el-table-column> -->
          </el-table>
        </el-row>
      </el-form>
    </div>
  </div>
</template>



<script>
// import mycartitem from "@/components/mycartitem.vue";
import axios from "axios";
import global from "../global.vue";
import AES from "../AES.js";
import XLSX from "xlsx";

export default {
  data() {
    return {
      jobno: "",
      dataForm: {
        sId: "",
        oMain: {},
        lItem: [{}],
      },
    };
  },
  created() {
    this.getParams();
    this.getdata();
  },
  methods: {
    gotomain(){
       this.$router.push({
        path: "/qtindex/deliverylist",
      });
     
    },
    getParams() {
      this.jobno = this.$route.query.jobno;
    },
    getdata() {
      let that = this;
      var stoken = window.localStorage.getItem("stoken");
      // axios.defaults.headers.common["token"] = stoken;
      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "getdeliveryanditembyjobno",
        data: that.jobno,
      })
        .then(function (res) {
          console.log(res.data);
          //TO-DO 先判断下数据是否正确 status
          that.dataForm = res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>


